'use client'
import { DataList } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'

const DataLineLoading = () => {
  return (
    <DataList.Line>
      <Skeleton className="h-md w-[100%] rounded-[20px]" />
    </DataList.Line>
  )
}

/**
 * Mirrors `VaultRiskCurationClient` with one allocator per column: most visited V1 vaults
 * have one or two allocators.
 */
const AllocatorDataListLoading = () => {
  return (
    <div className="gap-2xs flex w-[100%] flex-col items-start">
      <DataList.Root fullWidth>
        <DataList.Column>
          <DataLineLoading />
        </DataList.Column>
        <DataList.Column>
          <DataLineLoading />
        </DataList.Column>
      </DataList.Root>
    </div>
  )
}

export default AllocatorDataListLoading
